import React, { useEffect, useState } from 'react'
import MaterialTable from 'material-table'
import { Chip, LinearProgress } from '@material-ui/core'
import locationDataColumn from '../../dataColumns/locationDataColumn'
import useLocations from '../../hooks/modules/location/useLocations'
import useTableIcons from '../../hooks/useTableIcons'
import { SearchBar } from '../../components/searchBox/SearchBar'
import useStyles from '../../hooks/useStyles'
import { ModalDialog, ToolBar } from '../../components/tools'
import { Strings } from '../../assets/res/en'
import Unauthorized from '../../components/Unauthorized'
import MerchantQRModal from '../../components/Modals/MerchantQRModal'

export default function Locations(props) {

    const onQRCodeSelected = (data) => {
        console.log('Se seleccionao un QR', data)
        onOpenQrModal(data)
        //getAllPrograms();
      }

    const { locations,
        groupsMenus,
        isLoading,
        searchOptions,
        filters,
        openDialog,
        actions,
        handleModalClose,
        handleActionClick,
        modalHeader,
        modalContent,
        modalActions,
        modalFormResetKeys,
        modalTaskRunning,
        modalFormError,
        locationPermission,
        updateQRMerchant
    } = useLocations()
    const { columns, sytlingOptions } = locationDataColumn(groupsMenus, onQRCodeSelected)
    const { tableIcons } = useTableIcons()
    const classes = useStyles()

    const [selected_data, setSelectedData] = useState()
    const [qrModal, setQrModal] = useState(false)
  
    useEffect(() => {
      if(selected_data){
        const _updateData = locations.find(el => 
            el.idMerchant === selected_data.idMerchant &&
            el.idGroup === selected_data.idGroup
        )
        setSelectedData(_updateData)
      }
    }, [locations])
  
    const onOpenQrModal = (_data) => {
      setSelectedData(_data)
      setQrModal(true)
    }
  
    const onCloseQRModal = () => {
        setQrModal(false)
        setSelectedData(null)
    }
  
    const onQRUpdated = async() => {
      getAllPrograms();
    }

    const merchant_actions = {updateQRMerchant}


    return (
        <>
            {
                locationPermission.read === true ?
                    <>
                        <MerchantQRModal
                            open={qrModal}
                            onClose={onCloseQRModal}
                            origin={selected_data}
                            actions={merchant_actions}
                            onCompleted={onQRUpdated}
                        />
                        <SearchBar options={searchOptions} />
                        <MaterialTable
                            title={Strings.MENU_LOCATIONS_TITLE}
                            icons={tableIcons}
                            columns={columns}
                            actions={actions}
                            data={locations}
                            options={sytlingOptions}
                            isLoading={isLoading}
                            localization={{ body: { editRow: { deleteText: Strings.COLUMN_LOCATION_DELETE_TEXT } } }}
                            components={{
                                Toolbar: props => (
                                    <div>
                                        <ToolBar {...props} onAction={handleActionClick} canCreate={locationPermission.create ?? false} />
                                        <div className={filters.length > 0 ? classes.filterContainer : ""}>
                                            {
                                                filters.map(fItem => (
                                                    fItem.isRemovable ?
                                                        <Chip key={fItem.name} color="default" label={fItem.value} onDelete={fItem.remove} /> :
                                                        <Chip key={fItem.name} color="default" label={fItem.value} />))

                                            }
                                        </div>
                                    </div>
                                )
                            }}
                        />
                        <ModalDialog open={openDialog}
                            handleClose={handleModalClose}
                            modalHeader={modalHeader}
                            modalContent={modalContent}
                            modalActions={modalActions}
                            modalFormResetKeys={modalFormResetKeys}
                            modalTaskRunning={modalTaskRunning}
                            modalFormError={modalFormError} />
                    </>
                    : locationPermission.read === false ?
                    <Unauthorized />:
                    <LinearProgress/>
            }
        </>
    )
}